import { Button, Divider, Form, Input, Layout, Select, Typography } from 'antd';
import auth from 'api/auth';
import { languagesValues } from 'routes/Main/Main';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import classes from './Reset.module.scss';
import React from 'react';
import LogoType from 'assets/img';
import { useAppSelector } from 'store/hook';

const { Title, Paragraph } = Typography;

const authType = window.REACT_APP_AUTH_TYPE !== 'REPLACE_REACT_APP_AUTH_TYPE' ? window.REACT_APP_AUTH_TYPE : process.env.REACT_APP_AUTH_TYPE; 
const loginAdress = authType === 'blitz' ? 'blitz-auth' : 'login';

export default function Reset() {
  const { messageApi } = useAppSelector((store) => store.windowState);  

  const [isLoading, setIsLoading] = React.useState(false);
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  const defaultLanguage = localStorage.getItem('language') || 'en';
  const navigate = useNavigate();

  React.useEffect(() => {
    const allErrors: any[] = [];
    form.getFieldsError().forEach(item => allErrors.push(item.errors))
    allErrors.flat()[0] && form.validateFields()
  }, [i18n.language])

  const onResetHandle = async (values: { email: string }) => {
    try {
      setIsLoading(true);
      await auth.sendEmailToRestore({email: values.email?.toLocaleLowerCase()});
      navigate(`/${loginAdress}`); 
      messageApi?.success(t('resetPassword.successSend'));
    } catch (err) {
      messageApi?.error(t('resetPassword.failedSend'));
    } finally {
      setIsLoading(false);
    }
  };

  const onLanguageChange = (value: string) => {
    localStorage.setItem('language', value);
    i18n.changeLanguage(value);
  };

  return (
    <div className={classes.mainWrap}>
      <Layout className={classes.subElem}>
        <Select
          className={classes.localizationSelect}
          defaultValue={defaultLanguage}
          onChange={onLanguageChange}
          style={{ minWidth: 130 }}
          options={languagesValues}
          optionLabelProp={'label'}
        />
        <div className={classes.card}>
          <div className={classes.typography}>
            <img src={LogoType} alt='Logotype' className={classes.logo}/>
            <Typography>
              <Title level={3}>{t('resetPassword.title')}</Title>
              <Paragraph className={classes.subTitle}>{t('resetPassword.recoveryTitle')}</Paragraph>
            </Typography>
          </div>
          <Form layout='vertical' className={classes.form} onFinish={onResetHandle} form={form}>
            <Form.Item
              name={'email'}
              label={t('login.email')}
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: t('login.inputEmail'),
                },
              ]}
            >
              <Input
                placeholder={t('login.email')}
                size='large'
                // prefix={<MailFilled style={{ fontSize: '90%' }} />}
                className={classes.input}
              />
            </Form.Item>

            <Form.Item shouldUpdate>
              <Button type='primary' htmlType='submit' loading={isLoading}>
                {t('Documents.details.agreement.send')}
              </Button>
            </Form.Item>
          </Form>
          <Divider />

          <Typography style={{ textAlign: 'center' }}>
            <Typography.Link href={`${loginAdress}`} className={classes.primary}>
              {t('login.returnToLogin')}
            </Typography.Link>
          </Typography>
        </div>
      </Layout>
    </div>
  );
}
